import { Renderer2, Component, OnInit, OnChanges, AfterViewInit, ViewChild, HostListener, ElementRef, ViewContainerRef, Type, Input, SimpleChanges, Inject, Injectable } from '@angular/core';
import { PopoverController, IonSearchbar } from '@ionic/angular';
import { UntypedFormGroup, FormBuilder, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Injector } from '@angular/core';
import { SharedDataService } from 'src/app/services/shared-data.service';
import { ApiService } from "../../services/api.service";
import { UtilService } from 'src/app/services/util.service';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-inform-signature-container',
  templateUrl: './inform-signature-container.component.html',
  styleUrls: ['./inform-signature-container.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: InformSignatureContainerComponent,
      multi: true,
    },
  ],
})
export class InformSignatureContainerComponent implements ControlValueAccessor, OnInit, OnChanges {

  @ViewChild('searchbar') searchbar: IonSearchbar;
  @Input() formControlName: any;
  @Input() inputName: any;
  @Input() form: UntypedFormGroup;
  @Input() isError: boolean;
  @Input() question: any;
  // Signatures from the sign-off being relaunched: { userId, userName, signatureImage, signatureImageData }.
  @Input() preValue: any[];
  @Input() userList: any;
  @Input() searchText: string = '';
  @Input() filteredUsers: any[] = [];
  currentSelectedUsers: string = '';
  childIsSignatureFilled: boolean;
  selectedUser: any[] = [];
  users: any[] = [];
  groupUsers: any;
  isCustomPopoverOpen = false;
  searchbarElement: any;
  isAddSignatureButtonEnabled = true;
  selectedSignatureId: number | null = null;
  signaturesArray: Array<{ id: number, textContent: string, isPopoverOpen: boolean, isDropDown: boolean, disableAdd: boolean, userId: string, questionSignId: string, questionSigImage: any, questionSigImageName: string }> = [{ id: 0, textContent: '', isPopoverOpen: false, isDropDown: false, disableAdd: true, userId: '', questionSignId: '', questionSigImage: '', questionSigImageName: '' }];
  currentSignatureData: any;
  private onChange: any = (obj: any) => { };
  private onTouch: any = () => { };
  initialUsersList: any[] = [];
  reserveUsersList: any[] = [];
  customPlaceholder: string = '';
  isDone: boolean = false;
  selectedPreUserName: string = '';
  testBool: boolean = false;
  isSavedState = false;
  tester: boolean = true;
  filteredData: any;
  freeTextCheck: boolean = false;

  constructor(
    private elementRef: ElementRef,
    public sharedDataService: SharedDataService,
    public utilService: UtilService,
    public apiService: ApiService,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.filteredUsers = this.users;
  }

  ngAfterViewInit() {

    if (this.question.isPredefinedSignature) {
      if (this.question.signatureUserss[0].userId === "6f545e05-72dc-471c-a352-95728c6cd261") {
        this.selectedPreUserName = this.sharedDataService.entityOwnerInfos.firstName + ' ' + this.sharedDataService.entityOwnerInfos.lastName;
      } else {
        this.selectedPreUserName = this.question.signatureUserss[0].userName;
      }


    }

    if (this.question.isFreeTextOnly) {
      this.customPlaceholder = 'Type Name';
    } else if (this.question.isUserSelectAndTextFree) {
      this.customPlaceholder = 'Search or Type Name';
    } else if (this.question.isUserSelectOnly) {
      this.customPlaceholder = 'Search';
    }


    if (this.question.isPredefinedSignature) {

      this.question.signatureUserss.map((user) => {
        if (user.userId === "6f545e05-72dc-471c-a352-95728c6cd261") {

          this.signaturesArray[0].textContent = this.sharedDataService.entityOwnerInfos.firstName + ' ' + this.sharedDataService.entityOwnerInfos.lastName;
          this.signaturesArray[0].isPopoverOpen = false;
          this.signaturesArray[0].userId = this.sharedDataService.entityOwnerInfos.userId;
          this.selectedUser.push({ id: 0, textContent: this.sharedDataService.entityOwnerInfos.firstName + ' ' + this.sharedDataService.entityOwnerInfos.lastName, userId: this.sharedDataService.entityOwnerInfos.userId });

          const userArray = this.signaturesArray.map(signature => ({ userId: signature.userId, userName: signature.textContent, signatureImage: signature.questionSigImageName, sigImage: signature.questionSigImage, isEmailNotification: this.question.isEmailNotification, isNotifySignedUsers: this.question.isNotifySignedUsers, isSMSNotification: this.question.isSMSNotification, isSystemNotification: this.question.isSystemNotification }));
          this.form.get(this.inputName).setValue(userArray);
        } else {

          this.signaturesArray[0].textContent = user.userName;
          this.signaturesArray[0].isPopoverOpen = false;
          this.signaturesArray[0].userId = user.userId;
          this.selectedUser.push({ id: 0, textContent: user.userName, userId: user.userId });

          const userArray = this.signaturesArray.map(signature => ({ userId: signature.userId, userName: signature.textContent, signatureImage: signature.questionSigImageName, sigImage: signature.questionSigImage, isEmailNotification: this.question.isEmailNotification, isNotifySignedUsers: this.question.isNotifySignedUsers, isSMSNotification: this.question.isSMSNotification, isSystemNotification: this.question.isSystemNotification }));
          this.form.get(this.inputName).setValue(userArray);
        }

      })
    }
    this.searchbarElement = this.elementRef.nativeElement.querySelector('.searchbar-input');

    if (this.question.isSpecifiedUserOnly) {
      this.filteredUsers = this.question.signatureUserss;
      this.initialUsersList = this.question.signatureUserss;
      this.reserveUsersList = this.question.signatureUserss;
    } else {
      const userList = this.userList || [];
      this.filteredUsers = userList.filter(user => user.userId !== "00000000-0000-0000-0000-000000000000");
      this.initialUsersList = userList.filter(user => user.userId !== "00000000-0000-0000-0000-000000000000");
      this.reserveUsersList = userList.filter(user => user.userId !== "00000000-0000-0000-0000-000000000000");
    }


    if (this.question.signatureGroups) {
      this.question.signatureGroups.map((group) => {
        this.apiService.GetPersonalModeUsersGroups(group.groupId)
          .subscribe((res: any) => {

            this.groupUsers = res.Result;
            this.groupUsers.map((groupUser) => {
              this.filteredUsers.push(groupUser);
            })
            console.log(this.filteredUsers)
          },
            (error) => {
              // Handle errors if any
              console.error('Error occurred:', error);
            })
      })


    }
    if (this.sharedDataService.savedFormStateData !== null) {
      console.log('saved status', this.sharedDataService.savedFormStateData)
      if (
        this.sharedDataService.savedFormStateData[this.formControlName] !== null &&
        Array.isArray(this.sharedDataService.savedFormStateData[this.formControlName])
      ) {
        this.isSavedState = true;

        const data = this.sharedDataService.savedFormStateData[this.formControlName];
        if (this.question.isPredefinedSignature) {
          this.filteredData = data;
        } else {
          this.filteredData = data.filter(item => item.sigImage);
        }


        const transformedData = this.filteredData.map((item, index) => {
          return {
            id: index + 0, // Generating dynamic IDs
            textContent: item.userName,
            isPopoverOpen: false,
            disableAdd: true,
            userId: item.userId,
            questionSignId: '',
            questionSigImage: item.sigImage,
            questionSigImageName: item.signatureImage // Modify as needed
          };
        });
        const transformedDataForSelectedUsers = this.filteredData.map((item, index) => {
          return {
            id: index + 0, // Generating dynamic IDs
            textContent: item.userName,
            userId: item.userId,
          };
        });

        this.signaturesArray = transformedData;
        this.selectedUser = transformedDataForSelectedUsers;

        const userIdsToRemove = this.signaturesArray.map(user => user.userId);

        // Filter out users from filteredUsers whose userId is present in userIdsToRemove
        this.filteredUsers = this.filteredUsers.filter(user => !userIdsToRemove.includes(user.userId));
        this.initialUsersList = this.initialUsersList.filter(user => !userIdsToRemove.includes(user.userId));


        if (this.question.isPredefinedSignature && this.signaturesArray[0].questionSigImage !== '') {
          this.tester = false;
          const userArray = this.signaturesArray.map(signature => ({ userId: signature.userId, userName: signature.textContent, signatureImage: signature.questionSigImageName, sigImage: signature.questionSigImage, isEmailNotification: this.question.isEmailNotification, isNotifySignedUsers: this.question.isNotifySignedUsers, isSMSNotification: this.question.isSMSNotification, isSystemNotification: this.question.isSystemNotification }));
          this.form.get(this.inputName).setValue(userArray);
        }
      } else {
        console.log('sig array testing', this.signaturesArray)
        console.error('Data is not an array or is null');
      }
    }


    // CG-1676: a relaunched sign-off brings back its in-form signatures. They are shown like a
    // restored saved state, and get new file names so submitting uploads them again with the new
    // sign-off, the same as signatures drawn here. Saved-state data for this question wins.
    const relaunchSignatures = Array.isArray(this.preValue) ? this.preValue.filter(sig => sig?.signatureImageData) : [];
    if (!this.isSavedState && relaunchSignatures.length > 0) {
      this.isSavedState = true;
      this.signaturesArray = relaunchSignatures.map((sig, index) => ({
        id: index,
        textContent: sig.userName || '',
        isPopoverOpen: false,
        isDropDown: false,
        disableAdd: true,
        userId: sig.userId || '',
        questionSignId: '',
        questionSigImage: sig.signatureImageData,
        questionSigImageName: `digital-signature${new Date().getTime()}_${Math.floor(Math.random() * 10000)}_${index}`
      }));
      this.selectedUser = this.signaturesArray.map(sig => ({ id: sig.id, textContent: sig.textContent, userId: sig.userId }));

      const signedUserIds = this.signaturesArray.map(sig => sig.userId);
      this.filteredUsers = this.filteredUsers.filter(user => !signedUserIds.includes(user.userId));
      this.initialUsersList = this.initialUsersList.filter(user => !signedUserIds.includes(user.userId));

      if (this.question.isPredefinedSignature) {
        this.tester = false;
      }

      const userArray = this.signaturesArray.map(signature => ({ userId: signature.userId, userName: signature.textContent, signatureImage: signature.questionSigImageName, sigImage: signature.questionSigImage, isEmailNotification: this.question.isEmailNotification, isNotifySignedUsers: this.question.isNotifySignedUsers, isSMSNotification: this.question.isSMSNotification, isSystemNotification: this.question.isSystemNotification }));
      this.form.get(this.inputName).setValue(userArray);
    }

    if (this.signaturesArray.length === 0) {
      this.signaturesArray = [{ id: 0, textContent: '', isPopoverOpen: false, isDropDown: false, disableAdd: true, userId: '', questionSignId: '', questionSigImage: '', questionSigImageName: '' }];

    }

    if (this.sharedDataService.savedFormStateData !== null) {
      if (this.question.isPredefinedSignature && this.sharedDataService.savedFormStateData[this.formControlName][0].sigImage === "") {
        console.log("not signed");
        this.signaturesArray = [{ id: 0, textContent: '', isPopoverOpen: false, isDropDown: false, disableAdd: false, userId: '', questionSignId: '', questionSigImage: '', questionSigImageName: '' }];
        this.selectedUser = [];
        this.question.signatureUserss.map((user) => {
          if (user.userId === "6f545e05-72dc-471c-a352-95728c6cd261") {

            this.signaturesArray[0].textContent = this.sharedDataService.entityOwnerInfos.firstName + ' ' + this.sharedDataService.entityOwnerInfos.lastName;
            this.signaturesArray[0].isPopoverOpen = false;
            this.signaturesArray[0].userId = this.sharedDataService.entityOwnerInfos.userId;
            this.selectedUser.push({ id: 0, textContent: this.sharedDataService.entityOwnerInfos.firstName + ' ' + this.sharedDataService.entityOwnerInfos.lastName, userId: this.sharedDataService.entityOwnerInfos.userId });

            const userArray = this.signaturesArray.map(signature => ({ userId: signature.userId, userName: signature.textContent, signatureImage: signature.questionSigImageName, sigImage: signature.questionSigImage, isEmailNotification: this.question.isEmailNotification, isNotifySignedUsers: this.question.isNotifySignedUsers, isSMSNotification: this.question.isSMSNotification, isSystemNotification: this.question.isSystemNotification }));
            this.form.get(this.inputName).setValue(userArray);
          } else {

            this.signaturesArray[0].textContent = user.userName;
            this.signaturesArray[0].isPopoverOpen = false;
            this.signaturesArray[0].userId = user.userId;
            this.selectedUser.push({ id: 0, textContent: user.userName, userId: user.userId });

            const userArray = this.signaturesArray.map(signature => ({ userId: signature.userId, userName: signature.textContent, signatureImage: signature.questionSigImageName, sigImage: signature.questionSigImage, isEmailNotification: this.question.isEmailNotification, isNotifySignedUsers: this.question.isNotifySignedUsers, isSMSNotification: this.question.isSMSNotification, isSystemNotification: this.question.isSystemNotification }));
            this.form.get(this.inputName).setValue(userArray);
          }

        })

        const sig = this.signaturesArray[0];
        const index = 0;
        const userIndex = this.selectedUser.findIndex(user => user.id === index);
        const sigUserIndex = this.signaturesArray.findIndex(user => user.id === index);
        if (userIndex !== -1) {
          this.selectedUser.splice(userIndex, 1);
        }
        if (sigUserIndex !== -1) {
          this.signaturesArray[sigUserIndex].questionSigImage = '';
          this.signaturesArray[sigUserIndex].isPopoverOpen = true;
        }
        // this.form.get(this.inputName).setValue(this.signaturesArray.map(signature => signature.userId).join('|'));
        const userArray = this.signaturesArray.map(signature => ({ userId: signature.userId, userName: signature.textContent, signatureImage: signature.questionSigImageName, sigImage: signature.questionSigImage, isEmailNotification: this.question.isEmailNotification, isNotifySignedUsers: this.question.isNotifySignedUsers, isSMSNotification: this.question.isSMSNotification, isSystemNotification: this.question.isSystemNotification }));
        this.form.get(this.inputName).setValue(userArray);

        this.isDone = true;
        this.testBool = false;
        this.tester = false;

        this.signaturesArray.forEach(user => {
          if (user.isPopoverOpen) {
            console.log('its true')
          } else {
            console.log('its false')
          }
        });
        sig.disableAdd = false;

      } else {
        console.log('signed');
      }
    }


  }

  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent) {
    const clickedElement = event.target as HTMLElement;
    const isClickedInsideDiv = this.isElementInsideDiv(clickedElement, 'yourDivId'); // Replace 'yourDivId' with the ID of your specific <div>

    // Check if the click is outside the div containing the search bar and popover
    if (!isClickedInsideDiv) {
      // Logic to set isCustomPopoverOpen to false when clicked outside the specific div
      this.isCustomPopoverOpen = false;

    }
  }

  @HostListener('document:touchstart', ['$event'])
  onDocumentTouchStart(event: TouchEvent) {
    const touchedElement = event.target as HTMLElement;
    const isTouchedInsideDiv = this.isElementInsideDiv(touchedElement, 'yourDivId'); // Replace 'yourDivId' with the ID of your specific <div>

    // Check if the touch is outside the div containing the search bar and popover
    if (!isTouchedInsideDiv) {
      // Logic to set isCustomPopoverOpen to false when touched outside the specific div
      this.isCustomPopoverOpen = false;
    }
  }

  private isElementInsideDiv(element: HTMLElement, divId: string): boolean {
    // Function to check if the clicked element is inside the specified div
    let currentElement = element;
    while (currentElement) {
      if (currentElement.id === divId) {
        return true;
      }
      currentElement = currentElement.parentElement;
    }
    return false;
  }

  ngOnInit() {
    this.renderer.listen('document', 'click', this.closeAllPopovers);
    this.renderer.listen('document', 'touchstart', this.closeAllPopovers);
  }
  closeAllPopovers = (event: TouchEvent) => {
    const touchedElement = event.target as HTMLElement;
    const signatures = this.elementRef.nativeElement.querySelectorAll('.signature-question-container');

    const isTouchedOutside = Array.from(signatures).every((signature: HTMLElement) => {
      return !signature.contains(touchedElement);
    });

    if (isTouchedOutside) {
      this.signaturesArray.forEach((signature) => {
        signature.isDropDown = false;
      });
    }
  };


  ngOnDestroy() {
  }

  ngOnChange() {
  }

  filterUsers(index: number, searchText: string, users) {
    console.log(index);
    if (searchText.trim() === '') {
      // If the search input is empty, show all users
      this.filteredUsers = users;
    } else {
      this.filteredUsers = users.filter(user => {
        if (user && user.userName) {
          return user.userName.toLowerCase().includes(searchText.toLowerCase());
        }
        return false;
      });
    }

    if (this.question.isFreeTextOnly || this.question.isUserSelectAndTextFree) {
      console.log(searchText);
      this.signaturesArray[index].disableAdd = false;
    }

  }

  afterAddAreaFilter(index: number, searchText: string, users) {

    if (searchText.trim() === '') {
      // If the search input is empty, show all users
      this.filteredUsers = users;
    } else {
      this.filteredUsers = users.filter(user => {
        if (user && user.userName) {
          return user.userName.toLowerCase().includes(searchText.toLowerCase());
        }
        return false;
      });
    }
  }

  // function to generate new none existing id
  generateUniqueUserId(existingUserIds: string[]): string {
    let userId: string;
    const hexCharacters = '0123456789abcdef';

    do {
      userId = '';
      for (let i = 0; i < 8; i++) {
        userId += hexCharacters.charAt(Math.floor(Math.random() * 16));
      }
      userId += '-';
      for (let i = 0; i < 4; i++) {
        userId += hexCharacters.charAt(Math.floor(Math.random() * 16));
      }
      userId += '-';
      for (let i = 0; i < 4; i++) {
        userId += hexCharacters.charAt(Math.floor(Math.random() * 16));
      }
      userId += '-';
      for (let i = 0; i < 4; i++) {
        userId += hexCharacters.charAt(Math.floor(Math.random() * 16));
      }
      userId += '-';
      for (let i = 0; i < 12; i++) {
        userId += hexCharacters.charAt(Math.floor(Math.random() * 16));
      }
    } while (existingUserIds.includes(userId));

    return userId;
  }

  addUser(index) {

    const newUserId = this.generateUniqueUserId(this.userList || []);
    const newTextContent = this.signaturesArray[index.id].textContent;
    const existingUserIndex = this.selectedUser.findIndex(user => user.id === index.id);

    if (this.signaturesArray[index.id].textContent.length > 0) {
      if (existingUserIndex !== -1) {
        this.selectedUser[existingUserIndex].textContent = newTextContent;
      } else {
        this.selectedUser.push({ id: index.id, textContent: newTextContent, userId: index.userId });
      }
      this.signaturesArray[index.id].isPopoverOpen = true;
      if (this.signaturesArray[index.id].userId.length === 0) {
        this.signaturesArray[index.id].userId = newUserId;
      }
      // this.form.get(this.inputName).setValue(this.signaturesArray.map(signature => signature.userId).join('|'));
      const userArray = this.signaturesArray.map(signature => ({ userId: signature.userId, userName: signature.textContent, signatureImage: signature.questionSigImageName, sigImage: signature.questionSigImage, isEmailNotification: this.question.isEmailNotification, isNotifySignedUsers: this.question.isNotifySignedUsers, isSMSNotification: this.question.isSMSNotification, isSystemNotification: this.question.isSystemNotification }));
      this.form.get(this.inputName).setValue(userArray);
    }

    let signatureUserIds = this.signaturesArray.map(signature => signature.userId);
    this.initialUsersList = this.initialUsersList.filter(user => !signatureUserIds.includes(user.userId));
    this.filteredUsers = this.initialUsersList.filter(user => !signatureUserIds.includes(user.userId));

    this.isDone = false;
    this.testBool = true;
    this.tester = true;

    index.disableAdd = true;
    console.log(index)
  }

  isUserInReserveList(i): boolean {
    return this.reserveUsersList.some(user => user.userName === this.signaturesArray[i].textContent && user.userId === this.signaturesArray[i].userId);

  }


  selectUser(user, index) {
    if (user.userId === "6f545e05-72dc-471c-a352-95728c6cd261") {
      this.signaturesArray[index].textContent = this.sharedDataService.entityOwnerInfos.firstName + ' ' + this.sharedDataService.entityOwnerInfos.lastName;
      this.signaturesArray[index].isPopoverOpen = false;
      this.signaturesArray[index].isDropDown = false;
      this.signaturesArray[index].disableAdd = false;
      this.signaturesArray[index].userId = this.sharedDataService.entityOwnerInfos.userId;

      this.initialUsersList = this.initialUsersList.filter(user => user.userId !== "6f545e05-72dc-471c-a352-95728c6cd261");
      this.filteredUsers = this.filteredUsers.filter(user => user.userId !== "6f545e05-72dc-471c-a352-95728c6cd261");
    } else {
      this.signaturesArray[index].textContent = user.userName;
      this.signaturesArray[index].isPopoverOpen = false;
      this.signaturesArray[index].isDropDown = false;
      this.signaturesArray[index].disableAdd = false;
      this.signaturesArray[index].userId = user.userId;

    }
    this.isCustomPopoverOpen = false;
    console.log('sig arr', this.signaturesArray)

  }

  onCloseAll() {
    this.isCustomPopoverOpen = false;
  }

  openPopover(index: number) {
    this.selectedSignatureId = index;
    const foundSignature = this.signaturesArray.find((item) => item.id === this.selectedSignatureId);
    const selected = this.selectedUser.find((item) => item.id === this.selectedSignatureId);

    if (selected !== undefined) {
      if (selected.textContent !== '') {
        this.isCustomPopoverOpen = false;
        foundSignature.isDropDown = false;

      } else {
        this.isCustomPopoverOpen = true;
        foundSignature.isDropDown = true;

      }
    } else {
      this.isCustomPopoverOpen = true;
      foundSignature.isDropDown = true;

    }



  }

  newSigPreArea(index) {
    console.log(index);
    console.log(this.selectedUser);
    console.log(this.signaturesArray);
  }

  removeUser(index: number, signature: any) {
    const userIndex = this.selectedUser.findIndex(user => user.id === index);
    if (userIndex !== -1) {
      this.selectedUser.splice(userIndex, 1);
    }
    // this.form.get(this.inputName).setValue(this.signaturesArray.map(signature => signature.userId).join('|'));
    const userArray = this.signaturesArray.map(signature => ({ userId: signature.userId, userName: signature.textContent, signatureImage: signature.questionSigImageName, sigImage: signature.questionSigImage, isEmailNotification: this.question.isEmailNotification, isNotifySignedUsers: this.question.isNotifySignedUsers, isSMSNotification: this.question.isSMSNotification, isSystemNotification: this.question.isSystemNotification }));
    this.form.get(this.inputName).setValue(userArray);

    this.isDone = true;
    this.testBool = false;
    this.tester = false;
    signature.disableAdd = false;
  }

  removeUserForSavedStat(index: number, sig: any) {
    const userIndex = this.selectedUser.findIndex(user => user.id === index);
    const sigUserIndex = this.signaturesArray.findIndex(user => user.id === index);
    if (userIndex !== -1) {
      this.selectedUser.splice(userIndex, 1);
    }
    if (sigUserIndex !== -1) {
      this.signaturesArray[sigUserIndex].questionSigImage = '';
      this.signaturesArray[sigUserIndex].isPopoverOpen = true;
    }
    // this.form.get(this.inputName).setValue(this.signaturesArray.map(signature => signature.userId).join('|'));
    const userArray = this.signaturesArray.map(signature => ({ userId: signature.userId, userName: signature.textContent, signatureImage: signature.questionSigImageName, sigImage: signature.questionSigImage, isEmailNotification: this.question.isEmailNotification, isNotifySignedUsers: this.question.isNotifySignedUsers, isSMSNotification: this.question.isSMSNotification, isSystemNotification: this.question.isSystemNotification }));
    this.form.get(this.inputName).setValue(userArray);

    this.isDone = true;
    this.testBool = false;
    this.tester = false;

    this.signaturesArray.forEach(user => {
      if (user.isPopoverOpen) {
        console.log('its true')
      } else {
        console.log('its false')
      }
    });
    sig.disableAdd = false;
  }

  removeSignature(sigUser, index) {
    // console.log("this.filteredUsers before removal", this.filteredUsers);
    // console.log("this.initialUsersList before removal", this.initialUsersList);
    const newUser = {
      userId: this.signaturesArray[index].userId,
      userName: this.getUserNameFromReserveList(this.signaturesArray[index].userId)
    };

    const isUserExists = this.initialUsersList.some(user => user.userId === newUser.userId);

    if (!isUserExists && this.reserveUsersList.some(user => user.userId === newUser.userId)) {
      this.initialUsersList.push(newUser);

      if (newUser.userId === this.sharedDataService.entityOwnerInfos.userId) {
        this.initialUsersList.push({
          userId: "6f545e05-72dc-471c-a352-95728c6cd261",
          userName: "# Entity Owner"
        });
      }
      this.initialUsersList.sort((a, b) => a.userName.localeCompare(b.userName));
    }


    this.signaturesArray = this.signaturesArray.filter(user => user.userId !== sigUser.userId);
    this.selectedUser = this.selectedUser.filter((user, currentIndex) => currentIndex !== index);




    // console.log("this.filteredUsers after removal", this.filteredUsers);
    // console.log("this.initialUsersList after removal", this.initialUsersList);

    const userArray = this.signaturesArray.map(signature => ({ userId: signature.userId, userName: signature.textContent, signatureImage: signature.questionSigImageName, sigImage: signature.questionSigImage, isEmailNotification: this.question.isEmailNotification, isNotifySignedUsers: this.question.isNotifySignedUsers, isSMSNotification: this.question.isSMSNotification, isSystemNotification: this.question.isSystemNotification }));
    this.form.get(this.inputName).setValue(userArray);

    this.testBool = false;
  }


  addSignatureArea() {
    this.signaturesArray.push({ id: this.signaturesArray.length, textContent: '', isPopoverOpen: false, isDropDown: false, disableAdd: true, userId: '', questionSignId: '', questionSigImage: '', questionSigImageName: '' });

    this.testBool = false;

    this.afterAddAreaFilter(0, '', this.initialUsersList);

  }

  clearUserId(index: number, sig: any) {
    const newUser = {
      userId: this.signaturesArray[index].userId,
      userName: this.getUserNameFromReserveList(this.signaturesArray[index].userId)
    };

    // Check if the user already exists in initialUsersList and filteredUsers arrays
    const isUserExists = this.initialUsersList.some(user => user.userId === newUser.userId);

    if (!isUserExists && this.reserveUsersList.some(user => user.userId === newUser.userId)) {
      this.initialUsersList.push(newUser);

      if (newUser.userId === this.sharedDataService.entityOwnerInfos.userId) {
        this.initialUsersList.push({
          userId: "6f545e05-72dc-471c-a352-95728c6cd261",
          userName: "# Entity Owner"
        });
      }
      this.initialUsersList.sort((a, b) => a.userName.localeCompare(b.userName));
    }

    const userArray2 = this.signaturesArray.filter(user => user.userId !== this.signaturesArray[index].userId)

    this.signaturesArray[index].userId = '';
    this.signaturesArray[index].textContent = '';
    this.signaturesArray[index].questionSigImage = '';
    this.signaturesArray[index].questionSigImageName = '';
    this.selectedUser.find(user => user.id === index).textContent = '';
    this.selectedUser.find(user => user.id === index).userId = '';

    const userArray = userArray2.map(signature => ({ userId: signature.userId, userName: signature.textContent, signatureImage: signature.questionSigImageName, sigImage: signature.questionSigImage, isEmailNotification: this.question.isEmailNotification, isNotifySignedUsers: this.question.isNotifySignedUsers, isSMSNotification: this.question.isSMSNotification, isSystemNotification: this.question.isSystemNotification }));

    this.form.get(this.inputName).setValue(userArray);


    this.testBool = false;
    sig.disableAdd = false;
  }

  getUserNameFromReserveList(userId: string): string {
    const user = this.reserveUsersList.find(user => user.userId === userId);
    return user ? user.userName : '';
  }

  shouldDisplaySelectedUser(id): boolean {
    return this.selectedUser.length > 0 && this.selectedUser.filter((elem) => elem.id === id)[0]?.textContent.length > 0;
  }

  getSelectedUserById(index: number): any {
    const selectedUser = this.selectedUser.find(user => user.id === index);
    return selectedUser;
  }

  shouldDisableAddButton(signatureId: number): boolean {
    return this.signaturesArray[signatureId].textContent.length === 0;
  }

  GetOutPutVal(selected: boolean) {
    if (selected) {
      this.childIsSignatureFilled = selected;

    }


  }

  GetOutPutQuestionVal(data, i) {

    if (data) {
      const uniqueFilename = `${new Date().getTime()}_${Math.floor(Math.random() * 10000)}`; // Create a unique filename

      this.currentSignatureData = data;
      if (this.question.isPredefinedSignature) {
        this.signaturesArray[0].questionSigImage = data.downlaodImg;
        this.signaturesArray[0].questionSignId = data.id;
        this.signaturesArray[0].questionSigImageName = data.downloadImgName + uniqueFilename;

        let existingArray = this.form.get(this.inputName).value;
        existingArray[data.id[data.id.length - 1]].signatureImage = this.signaturesArray[data.id[data.id.length - 1]].questionSigImageName;
        this.form.get(this.inputName).setValue(existingArray);

        this.form.get(this.inputName).setValue(existingArray);

      } else {
        this.signaturesArray[i].questionSignId = data.id ? data.id : "00000000-0000-0000-0000-000000000000";
        this.signaturesArray[i].questionSigImage = data.downlaodImg;
        this.signaturesArray[i].questionSigImageName = data.downloadImgName + uniqueFilename;
        let existingArray = this.form.get(this.inputName).value;
        existingArray[i].signatureImage = this.signaturesArray[i].questionSigImageName;
        this.form.get(this.inputName).setValue(existingArray);

      }


      const newItem = this.signaturesArray[i];



      this.sharedDataService.inSignatureUsersInfos = this.signaturesArray;



      const userArray = this.signaturesArray.map(signature => ({ userId: signature.userId, userName: signature.textContent, signatureImage: signature.questionSigImageName, sigImage: signature.questionSigImage, isEmailNotification: this.question.isEmailNotification, isNotifySignedUsers: this.question.isNotifySignedUsers, isSMSNotification: this.question.isSMSNotification, isSystemNotification: this.question.isSystemNotification }));
      this.form.controls[this.inputName]?.setValue(userArray);

    }

  }

  isAddButtonDisabled(signatureId): boolean {
    if (this.question.isUserSelectOnly) {
      let hasSelection = !!this.signaturesArray[signatureId].userId;
      return !hasSelection;
    }
    if (this.question.isFreeTextOnly || this.question.isUserSelectAndTextFree) {
      return this.signaturesArray[signatureId].textContent.trim() === '';
    }
    return false;
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  writeValue(obj: any): void {
    this.onChange(obj);
  }
}
